interface AdminListPaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}

const buttonClass =
  'px-3 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed';

export const AdminListPagination = ({
  page,
  pageSize,
  total,
  onPageChange,
}: AdminListPaginationProps) => {
  if (total <= 0) return null;
  const totalPages = Math.ceil(total / pageSize);
  const from = page * pageSize + 1;
  const to = Math.min((page + 1) * pageSize, total);
  return (
    <div className="flex items-center justify-between px-2">
      <div className="text-sm text-gray-600">
        Showing {from} to {to} of {total}
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(Math.max(0, page - 1))}
          disabled={page === 0}
          className={buttonClass}
        >
          Previous
        </button>
        <span className="text-sm text-gray-600">
          Page {page + 1} of {totalPages}
        </span>
        <button
          onClick={() => onPageChange(Math.min(totalPages - 1, page + 1))}
          disabled={page >= totalPages - 1}
          className={buttonClass}
        >
          Next
        </button>
      </div>
    </div>
  );
};
